import React from "react";
import { cn } from "@/lib/utils";
import { Eyebrow } from "@/components/marketing/MarketingPrimitives";

/** Consistent eyebrow + title + description block for marketing sections. */
export const SectionHeader = ({ eyebrow, title, description, align = "left", className }) => (
  <div className={cn("max-w-2xl", align === "center" && "mx-auto text-center", className)}>
    {eyebrow && (
      <div className={align === "center" ? "flex justify-center" : undefined}>
        <Eyebrow>{eyebrow}</Eyebrow>
      </div>
    )}
    <h2 className="mt-4 font-display text-2xl font-semibold tracking-[-0.01em] text-[color:var(--mk-text)] sm:text-3xl">
      {title}
    </h2>
    {description && (
      <p className="mt-4 text-sm leading-relaxed text-[color:var(--mk-text-2)] sm:text-base">{description}</p>
    )}
  </div>
);
